export default (api) => ({
    get: (params) => api.get('/event-consumption', { params }),
    detail: (params) => api.get('/event-consumption/detailed', { params }),
})
